import { Helmet } from 'react-helmet-async'

interface Props {
  title: string
  tags?: string
}

const Meta = ({ title, tags }: Props) => {
  const baseMeta = 'cloudsoft, blog, Marcin Malinowski, tutorial, cloud'
  const metaContent = tags ? `${baseMeta}, ${tags}` : baseMeta

  return (
    <Helmet>
      <title>{title}</title>
      <meta name='keywords' content={metaContent} />
    </Helmet>
  )
}

export default Meta
